export default __webpack_public_path__ + "static/media/magazziniere.081e5138.pdf";